.page {
  width: 100%;
  max-width: calc(var(--axl-content-max) + 2 * var(--axl-space-6));
  margin: 0 auto;
  padding: var(--axl-space-8) var(--axl-space-6) var(--axl-space-12);

  [data-size="mobile"] & {
    padding: var(--axl-space-5) var(--axl-space-4) var(--axl-space-8);
  }
}

.narrow {
  max-width: calc(var(--axl-reading-max) + 2 * var(--axl-space-6));
}

.header {
  display: flex;
  flex-wrap: wrap;
  gap: var(--axl-space-4);
  align-items: flex-end;
  justify-content: space-between;

  margin-bottom: var(--axl-space-8);

  [data-size="mobile"] & {
    margin-bottom: var(--axl-space-5);
  }
}

.headerText {
  min-width: 0;
}

.title {
  margin: 0;

  font-size: var(--axl-text-3xl);
  font-weight: 700;
  line-height: 1.2;
  color: var(--axl-text);
  letter-spacing: -0.02em;

  [data-size="mobile"] & {
    font-size: var(--axl-text-2xl);
  }
}

.subtitle {
  margin-top: var(--axl-space-2);
  font-size: var(--axl-text-lg);
  color: var(--axl-text-2);

  [data-size="mobile"] & {
    font-size: var(--axl-text-md);
  }
}

.actions {
  display: flex;
  gap: var(--axl-space-2);
  align-items: center;
}

.section {
  & + & {
    margin-top: var(--axl-space-10);
  }
}

.sectionHead {
  display: flex;
  flex-wrap: wrap;
  gap: var(--axl-space-3);
  align-items: center;
  justify-content: space-between;

  margin-bottom: var(--axl-space-4);
}

.sectionTitle {
  margin: 0;

  font-size: var(--axl-text-xl);
  font-weight: 650;
  line-height: 1.3;
  color: var(--axl-text);
  letter-spacing: -0.01em;
}

.sectionActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--axl-space-2);
  align-items: center;
}

.surface {
  background: var(--axl-surface);
  border: 1px solid var(--axl-hair);
  border-radius: var(--axl-radius-lg);
  box-shadow: var(--axl-shadow-2);
}

.padded {
  padding: var(--axl-space-5);
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: var(--axl-space-12) var(--axl-space-4);

  text-align: center;
}

.emptyImage {
  width: 100%;
  max-width: 320px;
  margin-bottom: var(--axl-space-6);
}

.emptyIcon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 64px;
  height: 64px;
  margin-bottom: var(--axl-space-4);

  font-size: 28px;
  color: var(--axl-primary);

  background: var(--axl-primary-soft);
  border-radius: var(--axl-radius-lg);
}

.emptyTitle {
  font-size: var(--axl-text-xl);
  font-weight: 600;
  color: var(--axl-text);
}

.emptyDescription {
  max-width: 420px;
  margin-top: var(--axl-space-2);
  color: var(--axl-text-2);
}

.emptyAction {
  margin-top: var(--axl-space-5);
}
